import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export function initializeAppInsights(instrumentationKey?: string): { appInsights: ApplicationInsights } {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: instrumentationKey || window.config?.instrumentationKey,
      extensions: [],
      disableFetchTracking: true,
      enableCorsCorrelation: false,
      enableRequestHeaderTracking: false,
      enableResponseHeaderTracking: false
    }
  })

  appInsights.loadAppInsights()
  return { appInsights }
}
